<template>
  <OneAlert
    :brandClass="brandClass()"
    v-if="isPasswordPopupVisible"
    :button_confirm_label="$t('applogin_continue_button')"
    :button_cancel_label="isBackButtonReplacingCancel ? $t('profile_back_button') : $t('profile_cancel_button')"
    @confirm="confirmPasswordPopup()"
    @close="closePasswordPopup"
    :title="$t('profile_account_data_personalID_authorization_modal_title')"
    :content="$t('login_page_password_error_required')"
  >
    <template v-slot:internal-content>
      <form @submit.prevent="validateUser" novalidate class="form">
        <div class="form_flex_container hidden">
          <div class="custom-field">
            <OneInput
              id="email"
              label=""
              :brandClass="brandClass()"
              :t="$t"
              :profileStyle="true"
              v-model="form.email"
              :form="v$.email"
              :paramName="'email'"
              @blur="touchForm('email')"
              :errors="[]"
            ></OneInput>
          </div>
        </div>
        <div class="form_flex_container" style="width: 100%">
          <div class="custom-field">
            <OneInput
              id="password"
              :label="$t('login_page_password_label')"
              :brandClass="brandClass()"
              :t="$t"
              :profileStyle="true"
              v-model="form.password"
              :form="v$.form"
              autocomplete="current-password"
              :paramName="'password'"
              @blur="touchForm('password')"
              :type="showPassword ? 'text' : 'password'"
              :showToggle="true"
              @toggleClick="() => (showPassword = !showPassword)"
              :errors="[
                {
                  message: $t('login_page_password_error_required'),
                  thereIsTheError: v$.form.password.required.$invalid,
                },
                {
                  message: $t('generic_error_profile_wrong_password'),
                  thereIsTheError: showPasswordError,
                },
              ]"
            ></OneInput>
          </div>
        </div>
      </form>
    </template>
  </OneAlert>
</template>
<script>
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PasswordPopup",
  inject: ["$c", "$t", "brandClass"],
  mixins: [oneUtils.accessibilityMixin, oneUtils.customValidationMixin],
  emit: ["closePasswordPopup", "userPassword", "passwordError"],
  setup: () => {
    return { v$: useVuelidate() };
  },
  components: {},
  validations: {
    form: {
      password: { required },
      email: {},
    },
  },
  data: () => ({
    form: {
      email: "",
      password: "",
    },
    showPasswordError: false,
    showPassword: false,
  }),
  props: ["isPasswordPopupVisible", "isBackButtonReplacingCancel", "passwordError", "resetPasswordFormProp"],
  methods: {
    resetPasswordForm() {
      this.form.password = "";
      this.showPassword = false;
      this.v$.$reset();
    },
    closePasswordPopup(isPasswordPopupClosedByBackButton) {
      this.resetPasswordForm();
      this.$emit("closePasswordPopup", isPasswordPopupClosedByBackButton);
    },
    confirmPasswordPopup() {
      this.touchForm("password");
      if (this.v$.$invalid) return;
      this.$emit("userPassword", this.form.password);
			//this.resetPasswordForm();
    },
    resetPasswordErrorProp() {
      this.$emit("resetPasswordError", false);
    },
  },
  watch: {
    passwordError: {
      handler() {
        if (this.passwordError) {
          this.showPasswordError = true;
          this.resetPasswordErrorProp();
        }
      },
    },
    "form.password": {
      handler() {
        this.showPasswordError = false;
      },
    },
    resetPasswordFormProp: {
      handler() {
        this.resetPasswordForm();
      },
    },
  },
  mounted() {
    this.form.email = this.$store.getters.getUser?.email;
  },
});
</script>
<style>
.form_flex_container.hidden {
  height: 0;
  width: 0;
  opacity: 0;
}
</style>
